"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PersonInitials = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp2;

var PersonInitials = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PersonInitials, _Component);

  function PersonInitials() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PersonInitials);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PersonInitials)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "name", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "literal", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      initials: "",
      length: -1,
      initialLength: 0,
      contentFontSize: ""
    };
    return _this;
  }

  babelHelpers.createClass(PersonInitials, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.resized);
      this.resized();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resized);
    }
  }, {
    key: "resized",
    value: function resized() {
      if (this._framePending) return;
      this._framePending = true;
      requestAnimationFrame(this.doResized);
    }
  }, {
    key: "doResized",
    value: function doResized() {
      this._framePending = false;
      var element = this.element;
      if (!element) return;

      if (element.offsetWidth === this.state.width && this.state.initials == this.state.lastKnownText) {
        // Do nothing: we didn't actually change.
        return;
      }

      var minFontSize = 12;
      var bbx = document.createElement('div');
      Object.assign(bbx.style, {
        position: 'fixed',
        top: '-1000px',
        left: '-1000px',
        width: element.offsetWidth + 'px',
        height: element.offsetHeight + 'px',
        overflow: 'hidden'
      });
      bbx.textContent = this.state.initials;
      element.appendChild(bbx);
      var fs = window.getComputedStyle(bbx).getPropertyValue('font-size');
      fs = Math.round(Number(fs.replace(/px$/, '')));
      var bfs = fs;
      var len = this.state.initials.length;
      bbx.style.fontSize = "".concat(fs, "px");

      do {
        while (fs > minFontSize && Math.round(bbx.scrollWidth) > Math.round(bbx.clientWidth)) {
          fs--;
          bbx.style.fontSize = "".concat(fs, "px");
        }

        if (Math.round(bbx.scrollWidth) > Math.round(bbx.clientWidth)) {
          len--;
          bbx.textContent = this.state.initials.substring(0, len);
          fs = bfs;
          bbx.style.fontSize = "".concat(fs, "px");
          continue;
        }

        break;
      } while (len > 1);

      element.removeChild(bbx);
      this.setState({
        width: element.offsetWidth,
        contentFontSize: "".concat(fs, "px"),
        length: len,
        lastKnownText: this.state.initials
      });
    }
  }, {
    key: "gotElement",
    value: function gotElement(ref) {
      this.element = ref;
      this.resized();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.initials != this.state.initials || !this.state.contentFontSize) {
        this.resized();
      }
    }
  }, {
    key: "render",
    value: function render() {
      // The actual initials go into ".initial-block", because we want to set the font size of that separately.
      return _react.default.createElement("span", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%'
        },
        className: "initial-container",
        ref: this.gotElement
      }, _react.default.createElement("span", {
        className: "initial-block",
        style: {
          fontSize: this.state.contentFontSize
        }
      }, this.state.initials.substring(0, this.state.length == -1 ? this.state.initialLength : this.state.length)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var name = _ref.name,
          literal = _ref.literal;
      return {
        initials: literal ? name : (name || "").split(/\s+/).filter(function (v) {
          return !!v;
        }).map(function (v) {
          return v.charAt(0);
        }).join("").toUpperCase(),
        initialLength: literal ? name.length : (name || "").split(/\s+/).filter(function (v) {
          return !!v;
        }).length
      };
    }
  }]);
  return PersonInitials;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "literal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "resized", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "resized"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doResized", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doResized"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotElement"), _class.prototype)), _class);
exports.PersonInitials = PersonInitials;
var ProfileImageContainer = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ProfileImageContainer, _Component2);

  function ProfileImageContainer() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ProfileImageContainer);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ProfileImageContainer)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "componentName", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "className", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "imageClassName", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "noImageClassName", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "extraClasses", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "image", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "name", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "literal", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "attributes", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(ProfileImageContainer, [{
    key: "render",
    value: function render() {
      if (this.image) return _react.default.createElement(this.componentName, babelHelpers.objectSpread({}, this.attributes, {
        className: _classList.default.join(this.className, this.imageClassName, this.extraClasses),
        style: {
          backgroundImage: "url(".concat(this.image, ")")
        }
      }));
      return _react.default.createElement(this.componentName, babelHelpers.objectSpread({}, this.attributes, {
        className: _classList.default.join(this.className, this.noImageClassName, this.extraClasses)
      }), _react.default.createElement(PersonInitials, {
        name: this.name,
        literal: this.literal
      }));
    }
  }]);
  return ProfileImageContainer;
}(_react.Component), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "componentName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "div";
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "imageClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "noImageClassName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "extraClasses", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "name", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "literal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "attributes", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
})), _class3);
exports.default = ProfileImageContainer;